import { useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { api } from "../lib/api";
import { useT } from "../contexts/LanguageContext";
import SEOHead from "../components/app/SEOHead";

export default function ForgotPassword() {
  const { t, lang } = useT();
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/password-reset/request", { email });
      setSent(true);
    } catch {
      // Endpoint never leaks whether email exists — always shows success.
      setSent(true);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-white grid lg:grid-cols-2">
      <SEOHead pageKey="login" />
      <div className="flex items-center justify-center p-8">
        <div className="w-full max-w-sm">
          <Link to="/" className="flex items-center gap-2 mb-10">
            <img src="/logo-full.png" alt="PMCoach AI" className="h-12 w-auto" />
          </Link>
          {!sent ? (
            <>
              <h1 className="font-display text-3xl font-bold" data-testid="forgot-title">
                {lang === "tr" ? "Parolamı unuttum" : "Forgot password"}
              </h1>
              <p className="text-slate-500 mt-2 text-sm">
                {lang === "tr"
                  ? "E-posta adresini gir, sana bir sıfırlama bağlantısı gönderelim."
                  : "Enter your email and we'll send you a reset link."}
              </p>
              <form onSubmit={submit} className="mt-8 space-y-4">
                <div>
                  <label className="text-sm font-semibold">{t("auth.email")}</label>
                  <input
                    type="email" required
                    value={email} onChange={(e) => setEmail(e.target.value)}
                    className="mt-1 w-full border border-slate-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-[#002FA7]"
                    data-testid="forgot-email-input"
                  />
                </div>
                <button
                  disabled={loading}
                  className="w-full btn-primary disabled:opacity-50"
                  data-testid="forgot-submit-button"
                >
                  {loading ? "..." : lang === "tr" ? "Bağlantı gönder" : "Send link"}
                </button>
              </form>
            </>
          ) : (
            <div className="mt-6" data-testid="forgot-success">
              <div className="rounded-lg bg-emerald-50 border border-emerald-200 p-4">
                <p className="text-emerald-900 font-semibold">
                  {lang === "tr" ? "E-postanı kontrol et ✉️" : "Check your email ✉️"}
                </p>
                <p className="text-emerald-800 text-sm mt-1">
                  {lang === "tr"
                    ? "Adresine bir sıfırlama bağlantısı gönderdik. Bağlantı 1 saat boyunca geçerli."
                    : "We sent a reset link to your address. The link is valid for 1 hour."}
                </p>
              </div>
            </div>
          )}
          <div className="mt-6 text-sm text-slate-500">
            <Link to="/login" className="text-[#002FA7] font-semibold hover:underline">
              ← {lang === "tr" ? "Girişe dön" : "Back to login"}
            </Link>
          </div>
        </div>
      </div>
      <div className="hidden lg:block bg-gradient-to-br from-[#002FA7] via-[#0F3FCF] to-[#5B47E0]" />
    </div>
  );
}
